import React from 'react';
import { MapPin } from 'lucide-react';

/**
 * Shown inside the venue-list header slot when there are zero venues to
 * render — either because location is unresolved or the map is zoomed
 * tight enough that no venues fall inside its bounds. Three visual
 * states, one per `locationStatus`.
 */
export function MapEmptyState({ locationStatus, onRequestLocation }) {
  return (
    <div
      data-testid="guest-map-empty-state"
      style={{ padding: '20px 20px 40px', textAlign: 'center', color: '#8A82A6', fontFamily: "'Inria Serif', serif" }}
    >
      <MapPin size={32} color="#D4CFE4" style={{ margin: '0 auto 8px' }} />
      {locationStatus === 'requesting' ? (
        <>
          <p style={{ fontSize: 15, fontWeight: 700, color: '#5B4AA3', margin: '4px 0' }}>Finding your location…</p>
          <p style={{ fontSize: 12.5, margin: 0 }}>Hang tight while we check where you are.</p>
        </>
      ) : locationStatus !== 'live' ? (
        <>
          <p style={{ fontSize: 15, fontWeight: 700, color: '#5B4AA3', margin: '4px 0' }}>Enable location to explore</p>
          <p style={{ fontSize: 12.5, margin: '0 0 12px' }}>Allure needs your location to surface venues and hidden gems within 20 km around you.</p>
          <button
            type="button"
            data-testid="guest-map-request-location"
            onClick={onRequestLocation}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '9px 16px',
              borderRadius: 9999,
              background: 'linear-gradient(135deg, #7C3AED 0%, #4F46E5 100%)',
              color: '#FFFFFF',
              border: 'none',
              fontFamily: "'Inria Serif', serif",
              fontSize: 13,
              fontWeight: 700,
              boxShadow: '0 8px 18px rgba(124, 58, 237, 0.32)',
              cursor: 'pointer',
            }}
          >
            Enable location
          </button>
        </>
      ) : (
        <>
          <p style={{ fontSize: 15, fontWeight: 700, color: '#5B4AA3', margin: '4px 0' }}>Check the map for venues</p>
          <p style={{ fontSize: 12.5, margin: 0 }}>
            This list only shows what&apos;s in the current map view — pan or zoom out to see more
          </p>
        </>
      )}
    </div>
  );
}
